module.exports = __webpack_public_path__ + "img/sec-09-eugene.d5d8f46b.svg";